import React from "react";
import DashboardIcon from "@/components/SVGComponents/SidebarIcons/DashboardIcon";
import BannerIcon from "@/components/SVGComponents/SidebarIcons/BannerIcon";
import EventIcon from "@/components/SVGComponents/SidebarIcons/EventIcon";

import ApprovalsIcon from "@/components/SVGComponents/SidebarIcons/ApprovalsIcon";
import ApplicationIcon from "@/components/SVGComponents/SidebarIcons/ApplicationIcon";
import UserManagmentIcon from "@/components/SVGComponents/SidebarIcons/UserManagmentIcon";
import PermissionIcon from "@/components/SVGComponents/SidebarIcons/PermissionIcon";
import PaymentIcon from "@/components/SVGComponents/SidebarIcons/PaymentIcon";
import SettingIcon from "@/components/SVGComponents/SettingIcon";

const Login = React.lazy(() => import("@/pages/Login/Login"));

const Banner = React.lazy(
  () => import("@/pages/Banner/Banner"),
);

const Events = React.lazy(
  () => import("@/pages/Events/Events"),
);

const Approvals = React.lazy(
  () => import("@/pages/Approval/Approvals"),
);
const Applications = React.lazy(
  () => import("@/pages/Applications/Applications"),
);

const ApplicationDetails = React.lazy(
  () => import("@/pages/ApplicationDetails/ApplicationDetails"),
);

const Dashboard = React.lazy(
  () => import("@/pages/Dashboard/Dashboard"),
);

const CreateEvent = React.lazy(
  () => import("@/pages/CreateEvent/CreateEvent"),
);

const AddBanner = React.lazy(
  () => import("@/pages/AddBanner/AddBanner"),
);

const OtpVerification = React.lazy(
  () => import("@/pages/OtpVerification/OtpVerification"),
);

const UserManagement = React.lazy(
  () => import("@/pages/UserManagement/UserManagement"),
);

const Permissions = React.lazy(
  () => import("@/pages/Permissions/Permissions"),
);

const Payments = React.lazy(
  () => import("@/pages/Payments/Payments"),
);

const Settings = React.lazy(
  () => import("@/pages/Settings/Settings"),
);

const routes = {
  routes: {
    LANDING_PAGE: {
      path: "/landing-page",
      element: <div>Landing Page</div>,
    },
    // ACCOUNT_VERIFICATION: {
    //   path: "/account-verification",
    //   element: <PreLogin />,
    //   children: [
    //     {
    //       path: "",
    //       element: <AccountVerification />,
    //     },
    //   ],
    // },
  },
  publicRoutes: {
    LOGIN: {
      path: "/login",
      element: <Login />,
    },
    OTP_VERIFICATION: {
      path: "/otp-verification",
      element: <OtpVerification />,
    },

  },
  privateRoutes: {
    DASHBOARD: {
      path: "/dashboard",
      element: <Dashboard />,
      pageName: "Dashboard",
      sidebar: {
        show: true,
        icon: DashboardIcon,
      },
      navbarCom: {
        search: false,
        // export: () => exportPageAsPDF("dashboard-export-content", "dashboard"),
        sendMessage: false,
      },
      // Dashboard is always visible — no requiredModule
    },
    BANNER: {
      path: "/banner",
      element: <Banner />,
      pageName: "Banner",
      sidebar: {
        show: true,
        icon: BannerIcon,
      },
      navbarCom: {
        search: false,
        // addbuttonLabel: () => "Add Banner",
        // addbuttonPath: "/add-banner",
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "banner",
    },
    ADD_BANNER: {
      path: "/add-banner",
      element: <AddBanner />,
      pageName: "Add Banner",
      sidebar: { show: false },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "banner",
      permissionName: "banner:create",
    },
    EDIT_BANNER: {
      path: "/edit-banner/:id",
      element: <AddBanner />,
      pageName: "Edit Banner",
      sidebar: { show: false },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "banner",
      permissionName: "banner:update",
    },
    // ADD_BANNER: {
    //   path: "/add-banner",
    //   element: <AddBanner />,
    //   pageName: "Add Banner",
    //   sidebar: {
    //     show: false,
    //   },
    //   navbarCom: {
    //     search: false,
    //     filter: false,
    //     export: false,
    //     sendMessage: false,
    //   },
    // },
    EVENTS: {
      path: "/events",
      element: <Events />,
      pageName: "Events",
      sidebar: {
        show: true,
        icon: EventIcon,
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "events",
    },
    APPROVAL: {
      path: "/approval",
      element: <Approvals />,
      pageName: "Approvals",
      sidebar: {
        show: true,
        icon: ApprovalsIcon,
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "users",
    },
    APPLICATION: {
      path: "/application",
      element: <Applications />,
      pageName: "Applications",
      sidebar: {
        show: true,
        icon: ApplicationIcon,
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "applications",
    },
    APPLICATION_DETAILS: {
      path: "/application/:id",
      element: <ApplicationDetails />,
      pageName: "Application Details",
      sidebar: {
        show: false,
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "applications",
    },
    CREATE_EVENTS: {
      path: "/create-event",
      element: <CreateEvent />,
      pageName: "Create Events",
      sidebar: {
        show: false
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "events",
    },
    PAYMENTS: {
      path: "/payments",
      element: <Payments />,
      pageName: "Payments",
      sidebar: {
        show: true,
        icon: PaymentIcon,
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "payments",
    },
    USER_MANAGEMENT: {
      path: "/user-management",
      element: <UserManagement />,
      pageName: "User Management",
      sidebar: {
        show: true,
        icon: UserManagmentIcon,
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredModule: "users",
    },
    PERMISSIONS: {
      path: "/permissions",
      element: <Permissions />,
      pageName: "Permissions",
      sidebar: {
        show: true,
        icon: PermissionIcon,
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
      requiredRole: "SUPER_ADMIN",
    },
    SETTINGS: {
      path: "/settings",
      element: <Settings />,
      pageName: "Settings",
      sidebar: {
        show: true,
        icon: SettingIcon,
      },
      navbarCom: {
        search: false,
        filter: false,
        export: false,
        sendMessage: false,
      },
    },
  },
} as const;

export default routes;

// export: () =>
//           exportPageAsPDF("statistics-export-content", "statistics"),
// addbuttonLabel: () =>
//           checkPermission("to create user-suggestion admin") ? "Add" : null,
//         filter: true,